import axios from "axios";
import { ENV } from "../config/env";

export const api = axios.create({
  baseURL: ENV.API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  // No prior timeout existed anywhere in this codebase (checked — none found).
  // 25s bounds TBO-backed calls (e.g. cancellation charge fetch) so a hung
  // request fails with a distinguishable ECONNABORTED instead of hanging
  // indefinitely. Applies to every call through this shared instance.
  timeout: 25000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
